var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSearch2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M16.4716 17.5303C16.7645 17.8232 17.2394 17.8232 17.5323 17.5303C17.8252 17.2374 17.8252 16.7626 17.5323 16.4697L16.4716 17.5303ZM13.2716 14.3303L16.4716 17.5303L17.5323 16.4697L14.3323 13.2697L13.2716 14.3303ZM16.152 8.2C16.152 3.80934 12.5926 0.25 8.20195 0.25V1.75C11.7642 1.75 14.652 4.63776 14.652 8.2H16.152ZM8.20195 0.25C3.81129 0.25 0.251953 3.80934 0.251953 8.2H1.75195C1.75195 4.63776 4.63972 1.75 8.20195 1.75V0.25ZM0.251953 8.2C0.251953 12.5907 3.81129 16.15 8.20195 16.15V14.65C4.63972 14.65 1.75195 11.7622 1.75195 8.2H0.251953ZM8.20195 16.15C12.5926 16.15 16.152 12.5907 16.152 8.2H14.652C14.652 11.7622 11.7642 14.65 8.20195 14.65V16.15Z",
    fill: "#2f2b75"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch2);
export default __webpack_public_path__ + "static/media/search_2.0ed2830bda75667434213aba1abc9009.svg";
export { ForwardRef as ReactComponent };